export const COUNTRIES = [
  { code: 'egypt', name: 'Egypt' },
  { code: 'saudi_arabia', name: 'Saudi Arabia' },
  { code: 'united_arab_emirates', name: 'United Arab Emirates' },
  { code: 'kuwait', name: 'Kuwait' },
  { code: 'qatar', name: 'Qatar' },
  { code: 'bahrain', name: 'Bahrain' },
  { code: 'oman', name: 'Oman' },
  { code: 'jordan', name: 'Jordan' },
  { code: 'lebanon', name: 'Lebanon' },
  { code: 'syria', name: 'Syria' },
  { code: 'iraq', name: 'Iraq' },
  { code: 'yemen', name: 'Yemen' },
  { code: 'palestine', name: 'Palestine' },
  { code: 'sudan', name: 'Sudan' },
  { code: 'libya', name: 'Libya' },
  { code: 'tunisia', name: 'Tunisia' },
  { code: 'algeria', name: 'Algeria' },
  { code: 'morocco', name: 'Morocco' },
  { code: 'united_states', name: 'United States' },
  { code: 'canada', name: 'Canada' },
  { code: 'united_kingdom', name: 'United Kingdom' },
  { code: 'ireland', name: 'Ireland' },
  { code: 'france', name: 'France' },
  { code: 'germany', name: 'Germany' },
  { code: 'italy', name: 'Italy' },
  { code: 'spain', name: 'Spain' },
  { code: 'portugal', name: 'Portugal' },
  { code: 'netherlands', name: 'Netherlands' },
  { code: 'belgium', name: 'Belgium' },
  { code: 'switzerland', name: 'Switzerland' },
  { code: 'austria', name: 'Austria' },
  { code: 'sweden', name: 'Sweden' },
  { code: 'norway', name: 'Norway' },
  { code: 'denmark', name: 'Denmark' },
  { code: 'finland', name: 'Finland' },
  { code: 'poland', name: 'Poland' },
  { code: 'czech_republic', name: 'Czech Republic' },
  { code: 'greece', name: 'Greece' },
  { code: 'turkey', name: 'Türkiye' },
  { code: 'russia', name: 'Russia' },
  { code: 'ukraine', name: 'Ukraine' },
  { code: 'romania', name: 'Romania' },
  { code: 'hungary', name: 'Hungary' },
  { code: 'bulgaria', name: 'Bulgaria' },
  { code: 'serbia', name: 'Serbia' },
  { code: 'croatia', name: 'Croatia' },
  { code: 'china', name: 'China' },
  { code: 'japan', name: 'Japan' },
  { code: 'south_korea', name: 'South Korea' },
  { code: 'india', name: 'India' },
  { code: 'pakistan', name: 'Pakistan' },
  { code: 'bangladesh', name: 'Bangladesh' },
  { code: 'sri_lanka', name: 'Sri Lanka' },
  { code: 'philippines', name: 'Philippines' },
  { code: 'indonesia', name: 'Indonesia' },
  { code: 'malaysia', name: 'Malaysia' },
  { code: 'singapore', name: 'Singapore' },
  { code: 'thailand', name: 'Thailand' },
  { code: 'vietnam', name: 'Vietnam' },
  { code: 'australia', name: 'Australia' },
  { code: 'new_zealand', name: 'New Zealand' },
  { code: 'south_africa', name: 'South Africa' },
  { code: 'nigeria', name: 'Nigeria' },
  { code: 'kenya', name: 'Kenya' },
  { code: 'ethiopia', name: 'Ethiopia' },
  { code: 'ghana', name: 'Ghana' },
  { code: 'tanzania', name: 'Tanzania' },
  { code: 'uganda', name: 'Uganda' },
  { code: 'rwanda', name: 'Rwanda' },
  { code: 'brazil', name: 'Brazil' },
  { code: 'argentina', name: 'Argentina' },
  { code: 'mexico', name: 'Mexico' },
  { code: 'chile', name: 'Chile' },
  { code: 'colombia', name: 'Colombia' },
  { code: 'peru', name: 'Peru' },
  { code: 'venezuela', name: 'Venezuela' },
  { code: 'israel', name: 'Israel' },
  { code: 'iran', name: 'Iran' },
  { code: 'afghanistan', name: 'Afghanistan' },
  { code: 'other', name: 'Other' }
];

export function getCountryName(code) {
  const c = COUNTRIES.find((x) => x.code === code);
  return c ? c.name : code || '';
}

export function isEgypt(code) {
  return code === 'egypt';
}
